import { render, staticRenderFns } from "./ReferralDetailsContextMenu.vue?vue&type=template&id=b707ba3a"
import script from "./ReferralDetailsContextMenu.vue?vue&type=script&lang=js"
export * from "./ReferralDetailsContextMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports